// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18":"002db466958b9bff","367":"ca873032f1e287b7","642":"f6f03611010de5ef"}[chunkId] + ".js";
};